import { useEffect } from 'react';

import { electronApis } from '@/features/electron-api';
import { useIsInternalUser } from '@/hooks/useIsInternalUser';

import { meetingDebugStore } from './meeting-debug.store';

export function useMeetingDebugInputDeviceRecorder() {
  const isInternalUser = useIsInternalUser();

  useEffect(() => {
    if (!isInternalUser) return;

    return electronApis.transcriptionInputDevice.onDeviceChanged((payload) => {
      meetingDebugStore.record({
        kind: 'input_device_changed',
        summary: `Input device: ${payload.effectiveCurrentDevice?.name ?? 'none'}`,
        fields: payload,
      });
    });
  }, [isInternalUser]);
}

export function useMeetingDebugLog(meetingId: string | undefined) {
  useEffect(() => {
    meetingDebugStore.load(meetingId).catch(() => {});
  }, [meetingId]);
}
